import { render, staticRenderFns } from "./MacrosCard.vue?vue&type=template&id=45f873ca&"
import script from "./MacrosCard.vue?vue&type=script&lang=ts&"
export * from "./MacrosCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports